import { motion } from "framer-motion";
import { ShieldCheckIcon } from "lucide-react";
export function Guarantee() {
  return <section className="w-full bg-white py-14 sm:py-20" data-id="element-112" data-mp="1o4f0oolspeck">
      <div className="mx-auto max-w-lg px-5 sm:max-w-2xl" data-id="element-113" data-mp="1o5zw0gfxp1bh">
        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.45
      }} className="relative overflow-hidden rounded-3xl border-2 border-[#1e88e5]/20 bg-slate-50 p-7 text-center sm:p-10" data-id="element-114" data-mp="2223ghi109var">
          <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-[#1e88e5]/10" data-id="element-115" data-mp="14dtf9591nbkp">
            <ShieldCheckIcon className="h-10 w-10 text-[#1e88e5]" data-id="element-116" data-mp="1edu2h2a1abu6" />
          </div>
          <h2 className="mt-5 font-head text-2xl font-800 text-[#0f2547] sm:text-3xl" data-id="element-117" data-mp="1ebr3vtutfadu">
            🛡️ Garantía Total de 7 Días
          </h2>
          <p className="mt-2 font-head text-base font-700 text-[#1e88e5]" data-id="element-118" data-mp="lpodu4fv02p2">
            Planifica tu próximo caso con total tranquilidad.
          </p>
          <p className="mx-auto mt-4 max-w-lg text-sm leading-relaxed text-slate-600 sm:text-[15px]" data-id="element-119" data-mp="oxfac9teapsk">
            Si durante los primeros 7 días consideras que el Sistema Maestro no
            te ayuda a tomar mejores decisiones clínicas o no cumple con tus
            expectativas, simplemente escríbenos y te devolveremos el 100% de tu
            dinero, sin preguntas. Así de simple.
          </p>
        </motion.div>
      </div>
    </section>;
}